import Wave from "@/wave";
import MD5 from "md5.js";

export function findGetParameter(name) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
}

export async function sleep(t) {
  return new Promise(resolve => {
    setTimeout(resolve, t);
  });
}

export async function showWave(){
  //only show wave on public file or chrome

  let wave = new Wave();
  let type = "bars";
  wave.fromElement("vvvv_html5_api", "wave-canvas", {
    type
  });
}

export function postGetterCallback(action, value) {
  window.parent.postMessage(
    {
      event: "PB.Widget.API.CALLBACK." + action,
      data: value
    },
    "*"
  );
}
export function postEvent(eventName, data) {
  if (!window.parent || window.parent === window) {
    // console.log({
    //   eventName, data
    // });
  } else {
    window.parent.postMessage(
      {
        event: eventName,
        data: data
      },
      "*"
    );
  }
}

export function guid() {
  const s4 = function() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  };
  return (
    s4() +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    s4() +
    s4()
  );
}

export default function asyncLoadJs(url) {
  return new Promise((resolve, reject) => {
    let srcArr = document.getElementsByTagName("script");
    for (let i = 0; i < srcArr.length; i++) {
      if (srcArr[i].src === url) {
        resolve();
        return;
      }
    }

    let script = document.createElement("script");
    script.type = "text/javascript";
    script.src = url;
    document.body.appendChild(script);
    script.onload = () => {
      resolve();
    };
    script.onerror = () => {
      reject();
    };
  });
}


export function loadCss(url) {
  let css = document.createElement("link");
  css.href = url;
  css.rel = "stylesheet";
  css.type = "text/css";
  document.head.appendChild(css);
}

export function srt2webvtt(data) {
  // remove dos newlines
  var srt = data.replace(/\r+/g, '');
  // trim white space start and end
  srt = srt.replace(/^\s+|\s+$/g, '');

  // get cues
  var cuelist = srt.split('\n\n');
  var result = "";

  if (cuelist.length > 0) {
    result += "WEBVTT\n\n";
    for (var i = 0; i < cuelist.length; i=i+1) {
      result += convertSrtCue(cuelist[i]);
    }
  }

  return result;
}

function convertSrtCue(caption) {
  // remove all html tags for security reasons
  //srt = srt.replace(/<[a-zA-Z\/][^>]*>/g, '');

  var cue = "";
  var s = caption.split(/\n/);

  // concatenate muilt-line string separated in array into one
  while (s.length > 3) {
    for (var i = 3; i < s.length; i++) {
      s[2] += "\n" + s[i]
    }
    s.splice(3, s.length - 3);
  }

  var line = 0;

  // detect identifier
  if (!s[0].match(/\d+:\d+:\d+/) && s[1].match(/\d+:\d+:\d+/)) {
    cue += s[0].match(/\w+/) + "\n";
    line += 1;
  }

  // get time strings
  if (s[line].match(/\d+:\d+:\d+/)) {
    // convert time string
    var m = s[1].match(/(\d+):(\d+):(\d+)(?:,(\d+))?\s*--?>\s*(\d+):(\d+):(\d+)(?:,(\d+))?/);
    if (m) {
      cue += m[1]+":"+m[2]+":"+m[3]+"."+m[4]+" --> "
        +m[5]+":"+m[6]+":"+m[7]+"."+m[8]+"\n";
      line += 1;
    } else {
      // Unrecognized timestring
      return "";
    }
  } else {
    // file format error or comment lines
    return "";
  }

  // get cue text
  if (s[line]) {
    cue += s[line] + "\n\n";
  }

  return cue;
}
export function setDocumentTitle(episodeTitle,podcastTitle) {
  document.title = episodeTitle + " > " + podcastTitle;
}

export function getFileMimeType(file){
  let ext = file.replace(/\?.*/,'').replace(/.*\//,'').replace(/.*\./,'').toLowerCase()
  let mimeTypes = {
    "mid": "audio/midi",
    "midi": "audio/midi",
    "kar": "audio/midi",
    "mp3": "audio/mpeg",
    "ogg": "audio/ogg",
    "m4a": "audio/x-m4a",
    "ra": "audio/x-realaudio",
    "3gpp": "video/3gpp",
    "3gp": "video/3gpp",
    "ts": "video/mp2t",
    "mp4": "video/mp4",
    "mpeg": "video/mpeg",
    "mpg": "video/mpeg",
    "mov": "video/quicktime",
    "webm": "video/webm",
    "flv": "video/x-flv",
    "m4v": "video/x-m4v",
    "mng": "video/x-mng",
    "asx": "video/x-ms-asf",
    "asf": "video/x-ms-asf",
    "wmv": "video/x-ms-wmv",
    "avi": "video/x-msvideo"
  };

  return mimeTypes[ext];
}

export function md5(str){
  return new MD5().update(str).digest('hex');
}

export function padZero(str, len) {
    len = len || 2;
    var zeros = new Array(len).join('0');
    return (zeros + str).slice(-len);
}
export function invertColor(hex, bw) {
    if (hex.indexOf('#') === 0) {
        hex = hex.slice(1);
    }
    // convert 3-digit hex to 6-digits.
    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
        throw new Error('Invalid HEX color.');
    }
    var r = parseInt(hex.slice(0, 2), 16),
        g = parseInt(hex.slice(2, 4), 16),
        b = parseInt(hex.slice(4, 6), 16);
    if (bw) {
        // http://stackoverflow.com/a/3943023/112731
        return (r * 0.299 + g * 0.587 + b * 0.114) > 186
            ? '#000000'
            : '#FFFFFF';
    }
    // invert color components
    r = (255 - r).toString(16);
    g = (255 - g).toString(16);
    b = (255 - b).toString(16);
    // pad each with zeros and return
    return "#" + padZero(r) + padZero(g) + padZero(b);
}

export function getFontColor(fontColor,playerColor){
  if(!fontColor) {
      if(playerColor){
          fontColor = invertColor(playerColor,true);
      }
  }else if(fontColor === '#auto' || fontColor === 'auto') {
    if(playerColor){
      fontColor = invertColor(playerColor,true);
    }else{
      fontColor = null;
    }
  }

  fontColor = fontColor && fontColor.indexOf('#') === -1 ? '#' + fontColor : fontColor;
  return fontColor;
}

export function isIE() {
  return !!window.ActiveXObject || "ActiveXObject" in window;
}

export function openConnectWindow(url) {
  let iWidth = 600;
  let iHeight = 600;
  let iTop = (window.screen.availHeight - 30 - iHeight) / 2;
  let iLeft = (window.screen.availWidth - 10 - iWidth) / 2;
  window.open(
    url,
    "connect_window",
    "height=" +
      iWidth +
      ",width=" +
      iHeight +
      ",top=" +
      iTop +
      ",left=" +
      iLeft +
      ",toolbar=no,menubar=no,scrollbars=no, resizable=no,location=no, status=no",
  );
}

export function formatDuration(seconds) {
  if (seconds === null) {
    return null;
  }
  let hours = Math.floor(seconds / 3600);
  let minutes = Math.floor((seconds % 3600) / 60);
  seconds = Math.floor((seconds % 3600) % 60);

  if (minutes < 10) {
    minutes = `0${minutes}`;
  }

  if (seconds < 10) {
    seconds = `0${seconds}`;
  }

  if (hours > 0) {
    if (hours < 10) {
      hours = `0${hours}`;
    }

    return `${hours}:${minutes}:${seconds}`;
  } else {
    return `00:${minutes}:${seconds}`;
  }
}

export function parseDuration(str) {
  if (!str) {
    return 0;
  }

  let seconds = 0;
  let arr = str.split(":").reverse();
  for (let k in arr) {
    let num = parseInt(arr[k]);

    seconds += num * 60 ** k;
  }
  return seconds;
}

export function getFileExtension(url){
  return url.replace(/\?.*$/, '').replace(/^.*\./g,'');
}

export function isVideo(url){
  let extension = getFileExtension(url);
  if(["mp4", "m4v", "mpg", "mov", "avi", "flv", "3gp", "3g2", "wmv"].indexOf(extension) !== -1){
    return true;
  }else{
    return false;
  }
}
